/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AdcPlatformModel, AdcServicesModel } from '../models';

export const EnterprisePlatforms: AdcPlatformModel[] = [
    {
        title: 'VMWare',
        name: 'vmWare',
        active: true,
        description: 'platform_vmWare_description_long',
        services: [
            <AdcServicesModel>{ name: 'VMWare Platform', fileName: 'LBVMESXv8.zip' },
            <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMESXv8.zip.md5' },
            <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMESXv8.zip.sha256' }
        ]
    },
    {
        title: 'Hyper-V',
        name: 'hyperV',
        active: true,
        description: 'platform_hyperV_description_long',
        services:
            [
                <AdcServicesModel>{ name: 'Hyper-V Platform', fileName: 'LBVMHYPER-V3v8.zip' },
                <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMHYPER-V3v8.zip.md5' },
                <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMHYPER-V3v8.zip.sha256' }
            ]
    },
    {
        title: 'Nutanix',
        name: 'nutanix',
        active: true,
        description: 'platform_nutanix_description_long',
        services:
            [
                <AdcServicesModel>{ name: 'Nutanix Platform', fileName: 'LBVMKVMv8.zip' },
                <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMKVMv8.zip.md5' },
                <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMKVMv8.zip.sha256' }
            ]
    },
    {
        title: 'KVM',
        name: 'kvm',
        active: true,
        description: 'platform_kvm_description_long',
        services:
            [
                <AdcServicesModel>{ name: 'KVM Platform', fileName: 'LBVMKVMv8.zip' },
                <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMKVMv8.zip.md5' },
                <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMKVMv8.zip.sha256' }
            ]
    },
    {
        title: 'Xen',
        name: 'xen',
        active: true,
        description: 'platform_xen_description_long',
        services:
            [
                <AdcServicesModel>{ name: 'Xen Platform', fileName: 'LBVMXENv8.zip' },
                <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMXENv8.zip.md5' },
                <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMXENv8.zip.sha256' }
            ]
    },
    {
        title: 'Oracle VM VirtualBox',
        name: 'virtualBox',
        active: true,
        description: 'platform_virtualBox_description_long',
        services:
            [
                <AdcServicesModel>{ name: 'VirtualBox Platform', fileName: 'LBVMESXv8.zip' },
                <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMESXv8.zip.md5' },
                <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMESXv8.zip.sha256' }
            ]
    },
    // {
    //     title: 'Oracle VM Server',
    //     name: 'oracleVmServer',
    //     active: true,
    //     description: 'Some bla bla about this hypervisor? maybe',
    //     services:
    //         [
    //             <AdcServicesModel>{ name: 'Oracle VM Server Platform', fileName: 'LBVMXENv8.zip' },
    //             <AdcServicesModel>{ name: 'MD5', fileName: 'LBVMXENv8.zip.md5' },
    //             <AdcServicesModel>{ name: 'SHA', fileName: 'LBVMXENv8.zip.sha256' }
    //         ]
    // }
];
